// extracted by mini-css-extract-plugin
export default {"root":"nav-list_root__7vQCe","active":"nav-list_active__750+x"};